import { render, staticRenderFns } from "./InfoCustomer.vue?vue&type=template&id=81929810&"
import script from "./InfoCustomer.vue?vue&type=script&lang=js&"
export * from "./InfoCustomer.vue?vue&type=script&lang=js&"
import style0 from "./InfoCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports